import vmClient from 'app/services/vmClient';
import { Entity, IEntity, IEntityType } from 'app/types/entity';

export interface IPersistenceRequest extends IEntity {
  attributes: {
    permittedStreams: string[];
    requestUri: string;
    token: string;
  };
}

export type PersistenceRequest = Entity<IPersistenceRequest>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersistenceRequest: IEntityType<IPersistenceRequest> = vmClient.defineClass({
  typeName: 'Rtc.RtcServerService.RequestAuthorization',
  version:  1,

  attributes: {
    requestUri: {
      notNull: true,
      type: 'string',
    },
    token: {
      notNull: true,
      type: 'string',
    },
  },
});
